import classNames from 'classnames'
import React, { ReactElement, ReactNode } from 'react'
import { useStableId } from '../../utils'
import styles from './index.module.css'
import { RadioNotSelected } from './RadioNotSelected'
import { RadioSelected } from './RadioSelected'

export interface FormRadioProps extends Omit<React.HTMLProps<HTMLInputElement>, 'label'> {
  label: ReactNode
}

export function FormRadio({ style, className, label, ...props }: FormRadioProps): ReactElement {
  const labelId = useStableId()
  return (
    <label
      id={labelId}
      className={classNames('flex gap-2 items-center', props.disabled && styles.disabled, className)}
      style={style}
    >
      <span className={styles.radio}>
        <input type="radio" {...props} aria-labelledby={labelId} />
        <span aria-hidden="true">{props.checked ? <RadioSelected /> : <RadioNotSelected />}</span>
      </span>
      {label}
    </label>
  )
}
